import type { ParseSpec } from "@ext/markdown/core/edit/logic/Prosemirror/from_markdown";

const safeJsonParse = (jsonString: string) => {
	try {
		return JSON.parse(jsonString);
	} catch {
		return;
	}
};

const table: ParseSpec = {
	block: "table",
	getAttrs: ({ attrs }) => {
		if (attrs?.sortingOrder) attrs.sortingOrder = (attrs.sortingOrder as string).split(",");
		return attrs;
	},
};

const tableRow: ParseSpec = { block: "tableRow", getAttrs: (tok) => tok.attrs };

const readAlign = (attrs: unknown) => {
	if (!Array.isArray(attrs)) return null;
	const style = attrs.find(([name]) => name === "style")?.[1];
	return /text-align:\s*(left|center|right)/.exec(style ?? "")?.[1] ?? null;
};

const readWidth = (attrs: unknown) => {
	if (!Array.isArray(attrs)) return null;
	const width = attrs.find(([name]) => name === "colwidth")?.[1];
	return width ? [Number(width)] : null;
};

const tableCell: ParseSpec = {
	block: "tableCell",
	getAttrs: ({ attrs }) => {
		// A cell of a Markdown table states what belongs to its column as markdown-it attribute
		// pairs; a cell of an extended table is a Gramax tag, whose attributes are already an object.
		if (Array.isArray(attrs)) return { align: readAlign(attrs), colwidth: readWidth(attrs) };

		attrs && !attrs.colspan && delete attrs.colspan;
		attrs && !attrs.rowspan && delete attrs.rowspan;

		if (attrs?.filter) attrs.filter = safeJsonParse(attrs.filter as string);
		return attrs;
	},
};

export default { table, tableRow, tableCell };
